import { useIsLoggedIn } from "src/hooks/useIsLoggedIn";
import { usePromotion } from "src/hooks/usePromotion";
import { useWelcomePopup } from "src/hooks/useWelcomePopup";
import {
  Promotion,
  PromotionType,
  ShopType,
  WelcomePopup,
} from "src/types/graphql.d";
import { ApolloError } from "@apollo/client";

export interface AudienceSpecificPromoVars {
  slug: string;
  category: PromotionType;
  shopType: ShopType;
}

export type AudienceSpecificPromoData = Promotion | WelcomePopup;

export interface AudienceSpecificPromo {
  data: AudienceSpecificPromoData | undefined;
  loading: boolean;
  error: ApolloError | undefined;
}

const useAudienceSpecificPromo = ({
  slug,
  category,
  shopType,
}: AudienceSpecificPromoVars): AudienceSpecificPromo => {
  const isLoggedIn = useIsLoggedIn();
  const promo = usePromotion(slug, category, shopType);
  const welcomePromo = useWelcomePopup();

  const data = isLoggedIn
    ? promo.data?.promotion
    : welcomePromo.data?.miscellaneous.welcomePopup;

  return {
    data,
    loading: (isLoggedIn ? promo.loading : welcomePromo.loading) || false,
    error: isLoggedIn ? promo.error : welcomePromo.error,
  };
};

export default useAudienceSpecificPromo;
